import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Style from './PromotionalBanner.style';
import PropTypes from 'prop-types';

export const PromotionalBanner = ({ couponCode, leftImage, rightImage, mobileImage, children, backgroundColor, ariaLabel }) => {
  const history = useHistory();
  const [hasNotification, setHasNotification] = useState(false);

  const handleClick = couponCode
    ? () => {
        history.push(`/buy/?coupon=${couponCode}`);
      }
    : undefined;

  useEffect(() => {
    const check = () => {
      const exists = !!document.querySelector('.notification-box');
      setHasNotification(exists);
    };

    check();

    const observer = new MutationObserver(check);
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <Style
      backgroundColor={backgroundColor}
      className="promotional-banner"
      onClick={handleClick}
      role={couponCode ? 'button' : undefined}
      hasNotification={hasNotification}
      aria-label={ariaLabel}
      tabIndex={couponCode ? 0 : undefined}
      onKeyDown={
        couponCode
          ? (event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                handleClick();
              }
            }
          : undefined
      }
    >
      <div className="content-wrapper">
        <div className="wrapper left-img-wrapper">{leftImage}</div>
        <div className="text-wrapper">{children}</div>
        <div className="wrapper right-img-wrapper">{rightImage}</div>
      </div>
      {mobileImage}
    </Style>
  );
};

PromotionalBanner.propTypes = {
  couponCode: PropTypes.string,
  leftImage: PropTypes.node.isRequired,
  rightImage: PropTypes.node,
  mobileImage: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  backgroundColor: PropTypes.string
};
